import { z as builder } from "zod"
import { DEV_MODE } from "@/config"

export const loginSchema = builder.object({
    username: builder.string(),
    password: DEV_MODE ? builder.string().optional() : builder.string().nonoptional()
})
